import { IPayload } from './IPayload'
import { IReduxAction } from './IReduxAction'

export const action = (
  type: string,
  data?: any,
  error?: Error
): IReduxAction => {
  return {
    type,
    payload: {
      data,
      error
    } as IPayload
  }
}



// WEBPACK FOOTER //
// ./src/store/dispatchAction.ts